import streamApi from "@/api/streamApi";
import { v4 as uuidv4 } from "uuid";

let streamApiSubscriptions = [];

function unsubscribeAll() {
  streamApiSubscriptions.forEach(el => {
    el.active = false;

    const { machineId, channel, streamCallback } = el;
    streamApi.unsub(machineId, channel, streamCallback);
  });
  streamApiSubscriptions = [];
}

function unsubscribe(id) {
  const index = streamApiSubscriptions.findIndex(el => el.id === id);
  if (index >= 0) {
    const subscription = streamApiSubscriptions[index];
    const { machineId: targetMachineId, channel: targetChannel, streamCallback } = subscription;

    const subscriptions = streamApiSubscriptions.filter(value => {
      const { machineId, channel } = value;
      return targetMachineId === machineId && targetChannel === channel;
    });
    const subscriptionsActive = subscriptions.filter(el => el.active);

    subscription.active = false;
    if (subscriptionsActive.length === 1) {
      streamApi.unsub(targetMachineId, targetChannel, streamCallback);

      streamApiSubscriptions = streamApiSubscriptions.filter(el => !subscriptions.includes(el));
    }
  }
}

function subscribe(machine, channel, callback) {
  const id = uuidv4();

  const machineId = machine.Id;
  const subscription = {
    id,
    machineId,
    channel,
    callback,
    active: true,
    streamCallback: (...args) => {
      if (subscription.active && callback) {
        callback(...args);
      }
    }
  };
  streamApiSubscriptions.push(subscription);

  return subscription;
}

const streamApiCore = {
  subAny(machine, channelWildcard, callback) {
    const { id, machineId, streamCallback } = subscribe(machine, channelWildcard, callback);
    streamApi.subAny(machineId, channelWildcard, streamCallback);
    return id;
  },
  subLatestOnChannelsAfterDate(machine, channelWildcard, startingFromDate, callback) {
    const { id, machineId, streamCallback } = subscribe(machine, channelWildcard, callback);
    streamApi.subLatestOnChannelsAfterDate(
      machineId,
      channelWildcard,
      startingFromDate,
      streamCallback
    );
    return id;
  },
  subLastHrs(machine, channel, hours, callback) {
    const { id, machineId, streamCallback } = subscribe(machine, channel, callback);
    streamApi.subLastHrs(machineId, channel, hours, streamCallback);
    return id;
  },
  subLastCount(machine, channel, count, callback) {
    const { id, machineId, streamCallback } = subscribe(machine, channel, callback);
    streamApi.subLastCount(machineId, channel, count, streamCallback);
    return id;
  },
  subFrom(machine, channel, startingFromDate, callback) {
    const { id, machineId, streamCallback } = subscribe(machine, channel, callback);
    streamApi.subFrom(machineId, channel, startingFromDate, streamCallback);
    return id;
  },
  subLatest(machine, channel, callback) {
    const { id, machineId, streamCallback } = subscribe(machine, channel, callback);
    streamApi.subLatest(machineId, channel, streamCallback);
    return id;
  },
  subscribe(machine, channel, callback) {
    const { id, machineId, streamCallback } = subscribe(machine, channel, callback);
    streamApi.subscribe(machineId, channel, streamCallback);
    return id;
  },
  watchCpData(machine, channel, callback) {
    const { id, machineId, streamCallback } = subscribe(machine, channel, callback);
    streamApi.watchCpData(machineId, channel, streamCallback);
    return id;
  },
  retrieveHistorical(machine, channel, filters, callback) {
    const { id, machineId, streamCallback } = subscribe(machine, channel, callback);
    streamApi.retrieveHistorical(machineId, channel, filters, streamCallback);
    return id;
  },
  getChannels(machine, channelWildcard) {
    const machineId = machine.Id;
    return streamApi.getChannels(machineId, channelWildcard);
  },
  getQueryDataLast(machine, channel) {
    const machineId = machine.Id;
    return streamApi.getQueryDataLast(machineId, channel);
  },
  getQueryData(filters) {
    return streamApi.getQueryData(filters);
  },
  unsub(id) {
    unsubscribe(id);
  },
  unsubAll: () => {
    unsubscribeAll();
  }
};

export default streamApiCore;
